import React from 'react';

const CTASection = () => {
    return (
        <section className="cta-section">
            <div className="cta-glow"></div>
            <div className="cta-glow-2"></div>
            <div className="container">
                <div className="cta-wrapper reveal">
                    <span className="cta-tag"><i className="fa-solid fa-rocket"></i> Get Started Today</span>
                    <h2>Ready to transform your salon?</h2>
                    <p>Join hundreds of smart owners on the Vendor App and start receiving bookings from the Customer App
                        today.</p>
                    <div className="cta-buttons">
                        <a href="#" className="btn-primary btn-large" id="cta-register-btn">
                            <i className="fa-solid fa-store"></i> Register Your Salon Now
                        </a>
                        <a href="#modules" className="btn-ghost btn-large" id="cta-learn-btn">
                            Learn More <i className="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CTASection;
